// extracted by css-extract-rspack-plugin
export default {"labelTokenBase":"LabelToken-module__labelTokenBase__DgxCZQw","labelTokenDeleteButton":"LabelToken-module__labelTokenDeleteButton__Whr5eRv"};